<template>
  <v-list-item
    :key="resposta.id"
  >
    <v-list-item-content>
      <v-list-item-title>
        <v-row dense>
          <v-col cols="12" sm="4" class="text-truncate">
            <px-status-negociacao
              :status-negociacao="resposta.respostaCotacao.statusNegociacao"/>
            {{ resposta.respostaCotacao.fornecedor.pessoa.nome }}
            <px-popover-fornecedor :fornecedor-id="resposta.respostaCotacao.fornecedor.id"
                                   show-score/>
          </v-col>
          <v-col cols="12" sm="2">
            <px-forma-pagamento v-if="isRespondida"
                                :forma-pagamento="resposta.respostaCotacao.formaPagamento"
                                :prazo-pagamento="resposta.respostaCotacao.prazoPagamento"
                                :showDiv="true"/>
          </v-col>
          <v-col cols="12" sm="3">
            <v-tooltip bottom v-if="isRespondida">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  {{ resposta.valorMoedaConvertido.precoUnitario | currency }}
                  <div v-if="isMoedaEstrangeira" class="caption">
                    {{
                      resposta.precoUnitario |
                        currency(simboloMoeda,
                        resposta.cotacaoProduto.produto.casasDecimais,
                        configuracaoFormatacaoMoeda)
                    }}
                  </div>
                </div>
              </template>
              <span>Preço unitário</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" sm="3">
            <v-tooltip bottom v-if="isRespondida">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  {{ resposta.valorMoedaConvertido.total | currency }}
                  <px-moeda-chip :moeda="moeda" v-if="isMoedaEstrangeira"/>
                  <div v-if="isMoedaEstrangeira" class="caption">
                    {{
                      resposta.total |
                        currency(simboloMoeda, 2, configuracaoFormatacaoMoeda)
                    }}
                  </div>
                </div>
              </template>
              <span>Preço total</span>
            </v-tooltip>
            <px-situacao-cotacao-produto :situacao="resposta.situacao"/>
          </v-col>
        </v-row>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <px-especificacao-produto-comparavel
        :especificacao="cotacaoProduto.especificacaoProduto"
        :especificacao-fornecida="resposta.especificacaoProduto"/>
    </v-list-item-action>
    <v-list-item-action>
      <template v-if="isModalView">
        <px-resposta-detalhes-dialog-view
          :cotacao-id="cotacaoId"
          :resposta-id="resposta.respostaCotacao.id"
        />
      </template>
      <template v-else>
        <v-btn icon @click="onClickDetalhes">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { SituacaoRespostaCotacaoProduto } from 'px-business-components';
import moedaMixin from '@/mixins/moeda-mixin';
import pxRespostaDetalhesDialogView
  from '@/modules/cotacao/resposta/detalhes/RespostaDetalhesDialogView.vue';

export default {
  mixins: [moedaMixin],
  props: {
    resposta: {
      type: Object,
      required: true,
    },
    cotacaoProduto: {
      type: Object,
      required: true,
    },
    cotacaoId: {
      type: [String, Number],
      required: true,
    },
    isModalView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    moeda() {
      return this.resposta.respostaCotacao.moeda;
    },
    isRespondida() {
      return this.resposta.situacao === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
  },
  methods: {
    onClickDetalhes() {
      this.$router.push({
        name: 'main.cotacoes.respostas.detalhes',
        params: {
          id: this.cotacaoId,
          idResposta: this.resposta.respostaCotacao.id,
        },
      });
    },
  },
  components: { pxRespostaDetalhesDialogView },
};
</script>
